module.exports = __webpack_public_path__ + "img/open-data-loading.6e241b1c.gif";